<template>
	<ul>

	<li  v-if="dataFetch && minimumLoading"
          v-for="(result,index) in sortedArrayCheap"

          :class="['psp_'+result.psp_id, {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
          }]"
        >
          {{ getPspName(result.psp_id) }}<span style=" font-size: 18px; font-weight: bold; display: inline-block;margin: 0 20px;">{{ virgule_rec(result.costs.total_received_destination) }}</span><span style="font-weight: bold;  font-size: 14px; ">{{ virgule(result.costs.total_fees) }}</span> {{ Object.values(result.options.sending)[0] }} {{ result.transfer_time_product_rate}}</li></ul>

</template>

<script>
	export default{
		data(){
			return{

			}
		},
		props:['info','dataFetch','minimumLoading'],
		methods : {
			sortedArrayCheap() {
            function compare(a, b) {
            if (a.costs.total_fees < b.costs.total_fees)
              return -1;  
            if (a.costs.total_fees > b.costs.total_fees)
                return 1;
            return 0;
          }
        return this.info.results.sort(compare);
        }
	  }
	}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/ProviderResult.vue